module.exports = __webpack_public_path__ + "img/img1.328544a5.png";